import { TransactionSubStatusEnum } from "store/wallets/enums";

export const errorSubStatus = {
  [TransactionSubStatusEnum.AMOUNT_TOO_SMALL]: "You have entered an amount too small",
  [TransactionSubStatusEnum.INSUFFICIENT_FUNDS]: "Insufficient funds",
};
